import { createCustomXmlIdentityStore } from "../shared/customXmlIdentity";

// PowerPoint's route to the <jyloCheckOut> stamp: presentation.customXmlParts
// (PowerPointApi 1.7). Identical API shape to Excel's, so the loop is shared -- see
// ../shared/customXmlIdentity.
//
// PowerPoint's route to the <jyloCheckOut> stamp: presentation.customXmlParts
// (PowerPointApi 1.7). Identical API shape to Excel's, so the loop is shared -- see
// ../shared/customXmlIdentity.
//
// This read is correct and needs nothing from the client. What it needs is from the
// SERVER: PowerPoint surfaces a custom XML part only when ppt/presentation.xml lists it
// in <p:custDataLst><p:custData r:id="..."/></p:custDataLst>. A relationship in
// presentation.xml.rels is NOT enough. custDataLst is a PresentationML construct with no
// Word or Excel equivalent, which is exactly why a byte-identical stamp reads fine in
// both of those and returned nothing here.
//
// Proven by a deck whose custDataLst referenced the stamp: read correctly, actions live,
// carrying the ORIGINAL bare stamp. Neither a namespace nor the relationship's target
// form makes any difference -- both were suspected at length and neither mattered. See
// docs/assumptions.md A-2, which also records how that went wrong twice.
//
// DraftCheckOutMetadataStamper writes that entry as of projects 8bc906de, and the whole
// chain -- check out, open, Save, Check in -- has been run against a real deck. A .pptx
// checked out BEFORE that fix carries a stamp with no custData entry and still reads as
// not checked out; checking it out again rewrites the part and fixes it.
//
// 1.7 is a real floor: it is unavailable on volume-licensed perpetual Office and on
// iPad. The manifest requires it rather than degrading, because an add-in that cannot
// read the identity cannot do anything at all.

const store = createCustomXmlIdentityStore<PowerPoint.RequestContext, PowerPoint.CustomXmlPart>({
  hostName: "PowerPoint",
  run: (callback) => PowerPoint.run(callback),
  parts: (context) => context.presentation.customXmlParts,
});

export const readCheckOutIdentity = store.read;
export const writeCheckOutIdentity = store.write;
